import { render, staticRenderFns } from "./LowPriorityComponents.vue?vue&type=template&id=417e752b&"
import script from "./LowPriorityComponents.vue?vue&type=script&lang=ts&"
export * from "./LowPriorityComponents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports